const alphalinkMobileProduct = {
  name: {
    label: "Nom"
  },
  alphalinkMobileProductGroup: {
    label: "Groupe Alphalink"
  },
  alphalinkOffer: {
    label: "Offre principale"
  },
  alphalinkOptionEsim: {
    label: "Option Esim"
  },
  alphalinkOptionPortability: {
    label: "Option Portabilité"
  },
  alphalinkOptions: {
    label: "Options",
    label_Display: "Options précédentes",
    allowMoreField: {
      addLabel: "Ajouter",
      removeLabel: "Enlever",
      removingLabel: "Supprimer"
    }
  },
};

export default alphalinkMobileProduct;
